import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PrimeNGConfig } from 'primeng/api';
import { GroupsManagerService } from '../groups-manager.service';
import { element } from 'protractor';
import { AuthService } from 'src/app/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-groups-manager-add-model',
  templateUrl: './groups-manager-add-model.html',
  styleUrls: ['./groups-manager-add-model.scss']
})
export class GroupsManagerAddModelComponent implements OnInit {
  groupName: any;
  mnoMapping: any;
  apnName: any;
  loader: boolean = false;
  mnoMappingList: any = [];
  sourceProducts: Product[] = [];
  targetProducts: Product[] = [];
  bandTemplatesList: any = [];
  allDeviceslist: any = [];
  selectedMnoTemplate: any = {};
  sourceTotalBands: any = [];
  sourceFullSupportedBands: any = [];
  sourcePartiallySupportedBands: any = [];
  sourceNotSupported: any = [];
  targedTotalBands: any = [];
  targedFullSupportedBands: any = [];
  targedPartiallySupportedBands: any = [];
  targedNotSupported: any = [];
  fully: any = [];
  Partially: any = [];
  none: any = [];
  selectedFully: any = [];
  selectedPartially: any = [];
  selectednone: any = [];
  isEdit: boolean = false;
  edgeDevicesList: any = [];
  deviceSettings: any = {}
  deviceAPNsetObject: any = {};
  deviceAndAPNObject: any;
  buttonDisabled: boolean = true;
  formFieldsChange: boolean = false;
  removedFromSelection: any[] = [];
  templateDeviceBandsReset: any[] = [];
  editmnoMapping: any;
  masterDevicesAll: any[] = [];
  originalTargetedProducts: any[] = [];
  updateTemplate = false;
  constructor(public groupsMangerService: GroupsManagerService, private authService: AuthService,
    private toaster: ToastrService, private modalService: NgbModal,
    public dialogRef: MatDialogRef<GroupsManagerAddModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  ngOnInit(): void {
    if (Object.keys(this.data).length != 0) {
      if (this.data.isEdit == true)
        this.isEdit = true;
    }
    this.deviceSettings = {
      text: "Select Kpi",
      classes: "myclass custom-class",
      enableSearchFilter: true,
      singleSelection: false,
      labelKey: "guiName",
      badgeShowLimit: 1
    };
    this.getAllBandTemplates();

  }
  getAllBandTemplates() {  // API Call to get mno templates
    this.groupsMangerService.getAllBandTemplates().subscribe((res: any) => {
      this.bandTemplatesList = res.result.hits;
      this.bandTemplatesList.map(ele => {
        ele.template_name = ele?._source?.template_name;
        ele.bands = ele._source.bands;
      });
      this.getAllDevices();
    })
  }
  validateName(e) {  //to stop entering the special charators except -

    var k;
    k = e.charCode;    //  k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  changeEvent() {
    this.formFieldsChange = true;
  }
  closePopup(content) { // to close the Pop-Up
    if (!this.isEdit && content && this.formFieldsChange && (this.groupName || this.selectedMnoTemplate?._source?.template_name)) {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', modalDialogClass: "width-550", windowClass: " custom-modal-zindex ", backdrop: 'static', keyboard: false }).result.then(

      );
    } else if (this.isEdit && content && this.formFieldsChange) {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', modalDialogClass: "width-550",  windowClass: " custom-modal-zindex ", backdrop: 'static', keyboard: false  }).result.then(

      );
    }
    else {
      this.dialogRef.close();
    }

  }
  ChangeDevices(ev) {
    this.sourceProducts = [];
    this.selectedDevicesList?.map(ele => {
      ele._source.xedge_slice.modem?.map(item => {
        this.sourceProducts.push({
          _id: ele?._id,
          value: item?.imei,
          device_name: ele?.device_name,
          device_name_id: ele?.device_name + ' ' + item?.imei + ' ' + item?.deviceid,
          name: item?.imei,
          device_id: item?.deviceid,
          bands_4g: item.band_info?.SUPPORTED_BAND_4G,
          bands_5g: item.band_info?.SUPPORTED_BAND_5G,
          bands_nsa_5g: item.band_info?.SUPPORTED_BAND_NSA_5G,
          device_type: item.device_type,
          isSelected: false
        });

      })

    })
    this.updateBandsCount();
    this.updateSelectedBandsCount();
  }
  selectedDevicesList: any = [];
  getAllDevices() {  // to get the All Devices List
    this.loader = true;
    this.groupsMangerService.getAllNonGroupDevices().subscribe((res: any) => {
      this.loader = false;
      this.edgeDevicesList = res?.result;
      // res?.result?.hits.map((item: any) => {
      //   this.edgeDevicesList.push({
      //     device_name: item?._source.name,
      //     _id: item?._id,
      //     _source: item?._source,
      //     guiName: item._id + '(' + item._source.name + ')'
      //   })
      // })
      this.sourceProducts = [];
      this.edgeDevicesList?.map(ele => {

        ele?.imei && this.sourceProducts.push({
          _id: ele?._id,
          value: ele?.imei,
          device_name: ele?.device_name,
          device_name_id: ele?.device_name + ' ' + ele?.imei + ' ' + ele?.deviceid,
          name: ele?.imei,
          device_id: ele?.deviceid,
          bands_4g: ele.SUPPORTED_BAND_4G,
          bands_5g: ele.SUPPORTED_BAND_5G,
          bands_nsa_5g: ele.SUPPORTED_BAND_NSA_5G,
          device_type: ele.device_type,
          isSelected: false
        });

      })

      if (Object.keys(this.data).length != 0) {
        if (this.data.isEdit == true)
          this.isEdit = true;
        this.setTargetedList();
      } else {
        this.updateBandsCount();
        this.updateSelectedBandsCount();
      }
    }, err => {
      this.loader = false;
    })
  }
  setTargetedList() {
    const mastersList = [];
    const masterObj = [];
    this.groupName = this.data?.data?._source?.groupname;
    this.mnoMapping = this.data?.data?._source?.template_id;
    this.editmnoMapping = this.data?.data?._source?.template_id;
    let data: any = this.bandTemplatesList.filter(ele => ele._id == this.data?.data?._source?.template_id);
    this.selectedMnoTemplate = data?.[0];
    let dataList: any = [];
    this.groupsMangerService.getAllDevices().subscribe((res: any) => {
      this.loader = false;
      res?.result?.hits.map((item: any) => {
        mastersList.push({
          device_name: item?._source.name,
          device_name_id: item?.device_name + ' ' + item?.imei + ' ' + item?.deviceid,
          _id: item?._id,
          _source: item?._source,
          guiName: item?._id + '(' + item?._source.name + ')'
        })
      })
      mastersList?.map(ele => {

        ele._source?.xedge_slice?.modem?.map(item => {
          masterObj.push({
            _id: ele?._id,
            value: item?.imei,
            device_name: ele?.device_name,
            device_name_id: ele?.device_name + ' ' + item?.imei + ' ' + item?.deviceid,
            name: item?.imei,
            device_id: item?.deviceid,
            bands_4g: item?.band_info?.SUPPORTED_BAND_4G,
            bands_5g: item?.band_info?.SUPPORTED_BAND_5G,
            bands_nsa_5g: item?.band_info?.SUPPORTED_BAND_NSA_5G,
            device_type: item?.device_type,
            isSelected: false
          });

        })
      })
      this.masterDevicesAll = masterObj
      const arrayObj = []
      masterObj.map((ele: any) => {
        this.data?.data?._source?.devices.map(element => {
          if (ele.name == element.imei && ele.device_name == element.device_name && ele.device_id == element.deviceid) {
            arrayObj.push(ele);
          }
        })
      })
      this.originalTargetedProducts = [...arrayObj];
      this.targetProducts = arrayObj;
      this.updateBandsCount();
      this.updateSelectedBandsCount();
    })

  }
  findNewObjects(originalArray, modifiedArray) {
    // Convert original array objects to a map for faster lookup
    const originalMap = new Map(originalArray.map(item => [item.value, item]));

    // Filter modified array to find objects not present in the original array
    const newObjects = modifiedArray.filter(item => !originalMap.has(item.value));

    return newObjects;
  }

  createRecord() { // to save and update 
    let data: any = {};
    data.groupname = this.groupName;
    data.template_id = this.mnoMapping ? this.mnoMapping : '';
    data.template_name = this.selectedMnoTemplate?._source?.template_name ? this.selectedMnoTemplate?._source?.template_name : '';
    data.bands = this.selectedMnoTemplate?._source?.bands ? this.selectedMnoTemplate?._source?.bands : {};
    let pushedData = [];
    this.targetProducts.length > 0 && this.targetProducts.map((ele: any) => {
      let obj: any = {
        device_name: ele.device_name,
        // device_name_id: ele?.device_name + ' ' + ele?.name + ' ' + ele?.device_id,
        deviceid: ele.device_id,
        imei: ele.name
      }
      pushedData.push(obj)
    })
    data.devices = pushedData
    this.templateDeviceBandsReset = pushedData;
    if (this.isEdit) {
      data.groupid = this.data.data._id;
      this.loader = true;
      this.groupsMangerService.updateGroupManager(data, this.data.data._id).subscribe((res: any) => {
        this.loader = false;
        this.dialogRef.close();
        if (res && res.status == 200) {
          if (data.bands && Object.keys(data.bands).length != 0 && this.targetProducts.length > 0) {
            setTimeout(() => {
              const newObjects = this.findNewObjects(this.originalTargetedProducts, this.targetProducts);
              if (newObjects?.length > 0) {
                this.lockBands(data.bands, res.result._id);
              }
              this.groupName = '';

            }, 2000);
          } else {
            this.resetBandlockTemplate();
            this.groupName = '';
          }
          this.toaster.success("Group Updated successfully")
          this.resetBandlock();
          this.buttonDisabled = false;
        } else if (res.status == 412) {
          this.toaster.error(`A group "${this.groupName}" already exists.`)
        }
      }, err => {
        this.loader = false;
      })
    } else {
      this.loader = true;
      this.groupsMangerService.createGroupManager(data).subscribe((res: any) => {
        this.loader = false;
        if (data.bands && this.targetProducts.length > 0) {
          setTimeout(() => {
            this.lockBands(data.bands, res.result._id);
          }, 2000);
        }
        this.dialogRef.close();
      }, err => {
        this.loader = false;
      })
    }
  }
  resetBandlock() {
    let data = []
    for (let j = 0; j < this.removedFromSelection.length; j++) {
      data.push({
        deviceid: this.removedFromSelection[j]?.device_id,
        imei: this.removedFromSelection[j]?.value,
        condition: {
          'BAND_4G': this.removedFromSelection[j].bands_4g,
          'BAND_5G': this.removedFromSelection[j].bands_5g,
          'BAND_NSA_5G': this.removedFromSelection[j].bands_nsa_5g,
        }
      })
    }
    const obj = {
      status: "active",
      rule: "BandLocking",
      devices: data
    }
    if (data.length > 0) {
      this.groupsMangerService.bandLock(obj).subscribe((res: any) => {
        this.toaster.success("Bands locked successfully")
      })
    }
  }
  resetBandlockTemplate() {
    let data = []
    let filterdata = []
    for (let j = 0; j < this.templateDeviceBandsReset.length; j++) {
      filterdata = this.masterDevicesAll.filter((item) => item.value == this.templateDeviceBandsReset[j].imei);
      data.push({
        deviceid: this.templateDeviceBandsReset[j].deviceid,
        imei: this.templateDeviceBandsReset[j]?.imei,
        condition: {
          'BAND_4G': filterdata[0].bands_4g,
          'BAND_5G': filterdata[0].bands_5g,
          'BAND_NSA_5G': filterdata[0].bands_nsa_5g,
        }
      })

    }
    const obj = {
      status: "active",
      rule: "BandLocking",
      devices: data
    }
    if (data.length > 0) {
      this.groupsMangerService.bandLock(obj).subscribe((res: any) => {
        this.toaster.success("Bands locked successfully")
      })
    }
  }
  lockBands(bands: any, id) {
    let username = 'Viavi';
    let log = { user_name: username, log_text: `User executed band locking on device ${this.groupName.trim()}` }
    this.groupsMangerService.eventLog(log).subscribe((result: any) => {

    })
    const obj = {
      status: "active",
      rule: "BandLocking",
      groupid: id,
      groupname: this.groupName,
      condition: {
        'BAND_4G': bands?.bands_4g.length > 0 ? bands?.bands_4g : [0],
        'BAND_5G': bands?.bands_5g.length > 0 ? bands?.bands_5g : [0],
        'BAND_NSA_5G': bands?.bands_nsa_5g.length > 0 ? bands?.bands_nsa_5g : [0],
      }
    }
    this.groupsMangerService.bandLock(obj).subscribe((res: any) => {
      if (!this.isEdit) {
        this.apnLock(res?.result[0]);
      }
      return res?.result[0]
    })
  }
  apnLock(ruleid) {
    if (ruleid) {

      let user;
      this.authService.getCurrentUser().subscribe(result => {
        user = result
      })
      let waitInterval = setInterval(() => {
        this.groupsMangerService.getDevicesStatusByRuleId(ruleid).subscribe(async obj => {
          const imeiList = []
          const devices = []
          this.targetProducts && this.targetProducts.map(each => {
            if (!this.deviceAPNsetObject[each?.device_id] && obj?.[each?.device_id] != 'active') {

              imeiList.push(each?.value)
              devices.push({
                deviceid: each?.device_id,
                imei: each?.value,
                condition: {
                  apn: this.apnName,
                }
              })
            }
          })
          devices.length > 0 && this.apnName && this.apnName != '' && this.groupsMangerService.handleAPNSettings(devices, user?.name).subscribe((res: any) => {
            if (res?.status == 200) {
              let interval = setInterval(async () => {
                this.groupsMangerService.getAllDevicesWithParams(imeiList).subscribe(res => {
                  res && Object.keys(res).map(each => {
                    this.deviceAndAPNObject?.[each] != 'shown' && (this.deviceAndAPNObject[each] = res?.[each])
                  })
                  this.deviceAndAPNObject && Object.keys(this.deviceAndAPNObject).map(each => {
                    if (this.deviceAndAPNObject?.[each] == this.apnName) {
                      this.toaster.success(`APN set successfully on device ${each}`)
                      this.deviceAndAPNObject[each] = 'shown'
                    }
                    else {
                      this.deviceAndAPNObject[each] != 'shown' && this.toaster.success(`APN is being updated on device ${each}`)
                    }
                  })

                  this.deviceAndAPNObject && Object.values(this.deviceAndAPNObject).filter(each => each == 'shown').length == imeiList.length && clearInterval(interval)
                })

              }, 10000)

              let timeout = setTimeout(() => {
                this.deviceAndAPNObject && Object.keys(this.deviceAndAPNObject).map(each => {
                  this.deviceAndAPNObject[each] != 'shown' && this.toaster.error(`APN not set on device ${each}`)
                })
                clearInterval(interval)
                clearTimeout(timeout)
              }, 25000)
            }
          }, (error) => { alert('Error in setting up APN') })

          obj && Object.keys(obj).map(each => {
            Object.assign(this.deviceAPNsetObject, { [each]: obj?.[each] != 'active' ? true : false })
          })


          if (obj && !Object.values(obj).includes('active')) {
            clearInterval(waitInterval)
          }

        })
      }, 1000)

      let timeout = setTimeout(() => {
        clearInterval(waitInterval)
        clearTimeout(timeout)
      }, 12000)
    }
  }
  eneteredGroupName() {
    this.buttonDisabled = this.groupName ? false : true;
  }
  proceed() {
    this.editmnoMapping = this.mnoMapping
    this.buttonDisabled = this.groupName ? false : true;
    this.loader = true;
    setTimeout(() => {
      this.loader = false;
    }, 2000);
    this.updateBandsCount();
    this.updateSelectedBandsCount();
  }
  cancelPopup() {
    this.mnoMapping = this.data?.data?._source?.template_id;
  }

  changeTemplate(data, id) {  // metho to modify the devices bands adjust
this.updateTemplate = false;
    this.selectedMnoTemplate = data;
    if (this.isEdit && this.editmnoMapping != data?._id) {
      this.modalService.open(id, { ariaLabelledBy: 'modal-basic-title', modalDialogClass: "width-550", windowClass: " custom-modal-zindex ",  backdrop: 'static', keyboard: false }).result.then(
        

      );
      this.updateTemplate = true;
    }
    this.updateBandsCount();
    this.updateSelectedBandsCount();

  }

  pickListChange(event) {  // method to call when devices are change left to right or right to left

    this.buttonDisabled = this.groupName ? false : true;
    for (let i = 0; i < this.sourceProducts.length; i++) {
      for (let k = 0; k < event?.items?.length; k++) {
        if (this.sourceProducts[i]._id == event.items[k]._id) {
          this.removedFromSelection.push(this.sourceProducts[i])
        } else {
          let findObj = this.targetProducts.find(item => item._id == event.items[k]._id);
          let index = this.removedFromSelection.findIndex((item: any) => { return item._id == findObj?._id })
          if (index != -1) {
            this.removedFromSelection.splice(index, 1);
          }
        }
      }
    }
    this.updateBandsCount();
    this.updateSelectedBandsCount();

  }
  updateBandsCount() { // to modify the bands color and count for source bands
    var fully1 = [];
    var Partial = [];
    var none1 = [];
    this.sourceProducts.map(ele => ele.isSelected = false)
    if (!this.isEmpty(this.selectedMnoTemplate?.bands)) {
      for (let k = 0; k < this.sourceProducts.length; k++) {

        if (this.selectedMnoTemplate?.bands?.bands_4g.every(item => this.sourceProducts[k]?.bands_4g && this.sourceProducts[k]?.bands_4g.includes(item)) &&
          this.selectedMnoTemplate?.bands?.bands_5g.every(item => this.sourceProducts[k]?.bands_5g && this.sourceProducts[k]?.bands_5g.includes(item)) &&
          this.selectedMnoTemplate?.bands?.bands_nsa_5g.every(item => this.sourceProducts[k]?.bands_nsa_5g && this.sourceProducts[k]?.bands_nsa_5g.includes(item))) {
          fully1.push(this.sourceProducts[k])
        } else if ((this.selectedMnoTemplate?.bands?.bands_4g.some(item => this.sourceProducts[k].bands_4g && this.sourceProducts[k]?.bands_4g.includes(item))) ||
          (this.selectedMnoTemplate?.bands?.bands_5g.some(item => this.sourceProducts[k]?.bands_5g && this.sourceProducts[k]?.bands_5g.includes(item))) ||
          (this.selectedMnoTemplate?.bands?.bands_nsa_5g.some(item => this.sourceProducts[k]?.bands_nsa_5g && this.sourceProducts[k]?.bands_nsa_5g.includes(item)))) {
          Partial.push(this.sourceProducts[k])
        } else {
          none1.push(this.sourceProducts[k])
        }
      }
    }
    const updateFully = [...new Map(fully1.map(item => [item['name'] + '-' + item['_id'], item])).values()]
    const updatePartially = [...new Map(Partial.map(item => [item['name'] + '-' + item['_id'], item])).values()]
    const updateNone = none1
    for (let i = 0; i < updatePartially.length; i++) {
      for (let k = 0; k < updateFully.length; k++) {
        if (updatePartially[i].value == updateFully[k].value) {
          updateFully.splice(k, 1);
        }
      }
    }
    for (let i = 0; i < updateNone.length; i++) {
      for (let k = 0; k < updatePartially.length; k++) {
        if (updateNone[i].value == updatePartially[k].value) {
          updateNone.splice(i, 1);
        }
      }
    }
    for (let i = 0; i < updateNone.length; i++) {
      for (let k = 0; k < updateFully.length; k++) {
        if (updateNone[i].value == updateFully[k].value) {
          updateNone.splice(i, 1);
        }
      }
    }

    this.fully = updateFully;
    this.Partially = updatePartially;
    this.none = updateNone;
  }
  updateSelectedBandsCount() {  // to modify the bands color and count for selected bands
    var fully1 = [];
    var Partial = [];
    var none1 = [];
    this.targetProducts.map(ele => ele.isSelected = true)
    if (!this.isEmpty(this.selectedMnoTemplate?.bands)) {
      for (let k = 0; k < this.targetProducts.length; k++) {
        if (this.selectedMnoTemplate?.bands?.bands_4g.every(item => this.targetProducts[k]?.bands_4g && this.targetProducts[k]?.bands_4g.includes(item)) &&
          this.selectedMnoTemplate?.bands?.bands_5g.every(item => this.targetProducts[k]?.bands_5g && this.targetProducts[k]?.bands_5g.includes(item)) &&
          this.selectedMnoTemplate?.bands?.bands_nsa_5g.every(item => this.targetProducts[k]?.bands_nsa_5g && this.targetProducts[k]?.bands_nsa_5g.includes(item))) {
          fully1.push(this.targetProducts[k])
        } else if ((this.selectedMnoTemplate?.bands?.bands_4g.some(item => this.targetProducts[k]?.bands_4g && this.targetProducts[k]?.bands_4g.includes(item))) ||
          (this.selectedMnoTemplate?.bands?.bands_5g.some(item => this.targetProducts[k]?.bands_5g && this.targetProducts[k]?.bands_5g.includes(item))) ||
          (this.selectedMnoTemplate?.bands?.bands_nsa_5g.some(item => this.targetProducts[k]?.bands_nsa_5g && this.targetProducts[k]?.bands_nsa_5g.includes(item)))) {
          Partial.push(this.targetProducts[k])
        } else {
          none1.push(this.targetProducts[k])
        }
      }
    }
    const updateFully = [...new Map(fully1.map(item => [item['name'] + '-' + item['_id'], item])).values()]
    const updatePartially = [...new Map(Partial.map(item => [item['name'] + '-' + item['_id'], item])).values()]
    const updateNone = none1;
    for (let i = 0; i < updatePartially.length; i++) {
      for (let k = 0; k < updateFully.length; k++) {
        if (updatePartially[i].value == updateFully[k].value) {
          updateFully.splice(i, 1);
        }
      }
    }
    for (let i = 0; i < updateNone.length; i++) {
      for (let k = 0; k < updatePartially.length; k++) {
        if (updateNone[i].value == updatePartially[k].value) {
          updateNone.splice(i, 1);
        }
      }
    }
    for (let i = 0; i < updateNone.length; i++) {
      for (let k = 0; k < updateFully.length; k++) {
        if (updateNone[i].value == updateFully[k].value) {
          updateNone.splice(i, 1);
        }
      }
    }

    this.selectedFully = updateFully;
    this.selectedPartially = updatePartially;
    this.selectednone = updateNone;
  }

  setSourceBg(band, item, type) { // to change the color of bands based on selected mnotemplate
    let isdeviceAvilable = []

    if (item.isSelected == true) {
      isdeviceAvilable = this.selectedFully.filter((dev) => dev?.name == item?.name);
    } else {
      isdeviceAvilable = this.fully.filter((dev) => dev?.name == item?.name);
    }

    if (type == '4G') {
      if (this.selectedMnoTemplate?.bands?.bands_4g && this.selectedMnoTemplate?.bands?.bands_4g.includes(band)) {
        if (isdeviceAvilable.length > 0) {
          return 'successClass'
        } else {
          return 'partialClass'
        }
      } else {
        return 'greyClass'
      }
    } else if (type == '5G') {
      if (this.selectedMnoTemplate?.bands?.bands_5g && this.selectedMnoTemplate?.bands?.bands_5g.includes(band)) {
        if (isdeviceAvilable.length > 0) {
          return 'successClass'
        } else {
          return 'partialClass'
        }
      } else {
        return 'greyClass'
      }
    } else if (type == 'NSA5G') {
      if (this.selectedMnoTemplate?.bands?.bands_nsa_5g && this.selectedMnoTemplate?.bands?.bands_nsa_5g.includes(band)) {
        if (isdeviceAvilable.length > 0) {
          return 'successClass'
        } else {
          return 'partialClass'
        }
      } else {
        return 'greyClass'
      }
    }
  }
  isEmpty(obj) { //to check empty
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  }

}
export interface Product {
  _id?: string;
  value?: string;
  name?: string;
  bands_4g?: any;
  bands_5g?: any;
  bands_nsa_5g?: any;
  device_type?: any;
  device_name?: any;
  device_name_id?: any;
  device_id?: any;
  isSelected?: boolean;
  imei?: any

}
